import { render, staticRenderFns } from "./ScheduleRow.vue?vue&type=template&id=3b5452c2&scoped=true&"
import script from "./ScheduleRow.vue?vue&type=script&lang=js&"
export * from "./ScheduleRow.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleRow.vue?vue&type=style&index=0&id=3b5452c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5452c2",
  null
  
)

export default component.exports